<app-kiosk-header-atom
  [logoImageUrl]="logoImageUrl()"
  [logoUrl]="logoUrl()"
  [displayLogo]="displayLogo()"
  [backgroundColor]="backgroundColor()"
  [backgroundImage]="backgroundImage()"
  [backgroundUrl]="backgroundUrl()"
  [headerLandingText]="headerLandingText()"
  [displayLeavingSessionButton]="displayLeavingSessionButton()"
  [displayAllergenFilters]="showAllergenFiltersButton()"
  [allergenFilterCount]="appliedCatalogFilters().length"
  (openAllergenFilters)="openCatalogFilters()"
  [displayHomeButton]="displayHomeButton()"
  [displayBackButton]="displayBackButton()"
  [backButtonIconColor]="backButtonIconColor()"
  [buttonHomeText]="buttonHomeText()"
  [buttonBackgroundColor]="buttonBackgroundColor()"
  [buttonTextColor]="buttonTextColor()"
  [size]="size()"
  [logoWidth]="logoWidth()"
></app-kiosk-header-atom>

@if (catalogFiltersOpen() && catalogFilterOptions(); as options) {
  <app-shop-catalog-filters-dialog
    [centered]="true"
    [options]="options"
    [categories]="categoryTree()"
    [selection]="appliedCatalogFilters()"
    (dismissed)="catalogFiltersOpen.set(false)"
    (applied)="applyCatalogFilters($event)"
  ></app-shop-catalog-filters-dialog>
}

@if (blocks()?.length) {
  <!-- Sized for ~4 brand logos (Planet): fixed card width, group centered -->
  <div
    class="kiosk-brand-carousel w-full overflow-hidden [&_app-carousel-block>div>div]:flex [&_app-carousel-block>div>div]:w-full [&_app-carousel-block>div>div]:justify-[safe_center] [&_app-carousel-block>div>div]:gap-3 [&_app-carousel-block>div>div]:overflow-x-auto [&_app-carousel-block>div>div]:scrollbar-hide [&_app-carousel-block>div>div]:px-5 [&_app-carousel-block>div>div]:py-4 kiosk-xl:[&_app-carousel-block>div>div]:gap-4 kiosk-xl:[&_app-carousel-block>div>div]:px-8 kiosk-xl:[&_app-carousel-block>div>div]:py-6 [&_app-carousel-slide-card-block>div]:!w-44 [&_app-carousel-slide-card-block>div]:!max-w-none [&_app-carousel-slide-card-block>div]:!min-w-0 [&_app-carousel-slide-card-block>div]:shrink-0 [&_app-carousel-slide-card-block>div]:!pr-0 kiosk-xl:[&_app-carousel-slide-card-block>div]:!w-52 [&_app-carousel-slide-card-block_a]:flex [&_app-carousel-slide-card-block_a]:min-h-28 kiosk-xl:[&_app-carousel-slide-card-block_a]:min-h-36 [&_app-carousel-slide-card-block_a]:items-center [&_app-carousel-slide-card-block_a]:justify-center [&_app-carousel-slide-card-block_a]:!bg-contain [&_app-carousel-slide-card-block_a]:bg-center [&_app-carousel-slide-card-block_a]:bg-no-repeat"
  >
    <app-block-list [blockIdList]="blocks()!"></app-block-list>
  </div>
}
